import { useEffect } from 'react'
import { controlList } from './storage'

export default function useInitial() {
    useEffect(() => {
        controlList.load()
    }, [])
}
